const emptyUser = null;

export default emptyUser;
